module.exports = __webpack_public_path__ + "media/images/plans/online/about-ab7ccebbdafe282d74174a6ae5c2055e.jpg";